import { getRequest, postRequest } from '../tools/ajax.js'

//破产投标案件录入
const BidAdd = params => postRequest('/api/pc/Bankrupt/BidEnter', params);

// 投标案件查询
const BidSearch = params => postRequest('/api/pc/Bankrupt/BidCase', params);

// 投标案件详情查询
const BidDetail = params => postRequest('/api/pc/Bankrupt/BidDetail', params);

// 投标案件附件查询
const BidFile = params => postRequest('/api/pc/Bankrupt/BidFile', params);


//破产案件录入
const BankruptAdd = params => postRequest('/api/pc/Bankrupt/BankruptEnter', params);

//破产案件查询
const BankruptSearch  = params => postRequest('/api/pc/Bankrupt/BankruptCase', params);

// 破产案件详情查询
const BankruptDetail = params => postRequest('/api/pc/Bankrupt/BankruptDetail', params);

// 破产案件附件查询
const BankruptFile   = params => postRequest('/api/pc/Bankrupt/BankruptFile', params);

//破产案件删除
const BankruptDel = params => postRequest('/api/pc/Bankrupt/BankruptDel', params);


/// 用章申请
// const CaseSeal = params => postRequest('/api/pc/Option/CaseSeal', params);

// 用章申请录入
const SealApply = params => postRequest('/api/pc/Option/SealApply', params);

// 案件附件查询页面上传附件
const Fileupload   = params => postRequest('/api/pc/Option/Fileupload', params);

// 案件日志
const CaseLog   = params => postRequest('/api/pc/Option/CaseLog', params);

// 案件附件删除
const FileDel   = params => postRequest('/api/pc/Option/FileDel', params);

// 案件修改
const Edit   = params => postRequest('/api/pc/Bankrupt/BankruptEdit', params);

// 结案
const ClosingCase   = params => postRequest('/api/pc/Option/ClosingCase', params);

// 归档
const Archive   = params => postRequest('/api/pc/Option/CaseArchiving', params);

// 获取部门领导人
const GetDepartmentLeaders = params => postRequest('/api/pc/Option/GetDepartmentLeaders', params);

// 更改协理律师
const UpdateLawyer= params => postRequest('/api/pc/Option/UpdateLawyer', params);

// 未审核
const CaseProcess =  params => postRequest('/api/pc/Option/CaseProcess', params);

//已审核流程
const CaseApprover =  params => postRequest('/api/pc/Option/CaseApprover', params);

// 关联的案件
const LinkCase   = params => postRequest('/api/pc/Bankrupt/LinkBCase', params);


export {
    BidAdd,BidSearch,BidDetail,BidFile,BankruptAdd,BankruptSearch,BankruptDetail,
    BankruptFile,SealApply,Fileupload,FileDel,Edit,BankruptDel,CaseLog,ClosingCase,Archive,GetDepartmentLeaders,UpdateLawyer,CaseProcess,CaseApprover,LinkCase
}
